import { AppConfig } from '@/types/config';

/**
 * Default Configuration - Completely dynamic
 * This serves as a fallback when config files fail to load
 */
export const defaultConfig: AppConfig = {
  // App Configuration (Metadata & Pages)
  metadata: {
    name: 'Predii 360'
  },
  pages: {
    home: {
      name: 'Parts Counter Assistant',
      subTitle: 'Just tell me what you need - I\'ll help you find it',
      agentLabel: 'Parts Agent',
      welcomeTitle: 'Welcome to Parts Counter',
      welcomeSubTitle: 'What parts are you looking for? Type below or select from the options shown',
      searchPlaceholder: 'Search for parts... (e.g., brake pads, oil filter)',
      infoHeader: 'Your AI parts counter assistant powered by Predii Agent.',
      infoSubHeader: 'Finds parts the way you ask for them — understands shop talk, fixes typos, and knows that "brake shoes" and "brake pads" aren\'t always the same thing.',
      infoList: [
        {
          title: 'Data Sources',
          list: [
            {
              header: 'ACES PCdb',
              context: 'The ultimate parts library. If it\'s got a part, we know it.'
            },
            {
              header: 'Predii Taxonomy',
              context: 'Handpicked by auto experts, so you\'re not just getting data - you\'re getting wisdom on wheels.'
            },
            {
              header: 'VMRS',
              context: 'The maintenance playbook that keeps fleets running. Standard codes that make sense of every repair.'
            }
          ]
        }
      ],
      trendingSearches: [
        'Brake pads',
        'Oil filter',
        'Air filter',
        'Spark plugs',
        'Battery'
      ],
      recentSearches: [
        'Show me spark plug',
        'I\'m looking for oil filter',
        'Brake pads',
        'Air filter',
        'Ignition Coil',
        'Serpentine Belt',
        'Alternator Assembly',
        'Strut Mount'
      ]
    }
  },

  // Static Configuration (Layout) - currently empty
  layout: {},

  // Dynamic Configuration - completely dynamic
  // Any additional properties can be added here
}; 